import { ComponentProps } from 'react'
import { Panel } from 'react-resizable-panels'

import { useResponsive } from 'src/hooks/useResponsive'
import {
    AI_PANEL_MIN_MOBILE_PHONE_SIZE,
    AI_PANEL_MIN_TABLET_SIZE,
    AI_PANEL_MIN_DESKTOP_SIZE,
    AI_PANEL_SIZE_TRANSITION_CLASSNAME,
} from 'src/components/constants'

export const AI_PANEL_ID = 'ai-panel'

const resolveAiPanelMinSize = (isMobilePhone: boolean, isTablet: boolean): number => {
    if (isMobilePhone) {
        return AI_PANEL_MIN_MOBILE_PHONE_SIZE
    }
    if (isTablet) {
        return AI_PANEL_MIN_TABLET_SIZE
    }

    return AI_PANEL_MIN_DESKTOP_SIZE
}

type AIPanelProps = Pick<ComponentProps<typeof Panel>, 'ref' | 'onExpand' | 'onCollapse' | 'children'> & {
    onExpand: (updateRef?: boolean) => void
    onCollapse: (updateRef?: boolean) => void
    animateSize?: boolean
}

export const AIPanel = (props: AIPanelProps) => {
    const { ref, onExpand, onCollapse, children, animateSize = false } = props
    const { isTablet, isMobilePhone } = useResponsive()
    const minSize = resolveAiPanelMinSize(isMobilePhone, isTablet)
    /* Phone starts collapsed: 95% defaultSize leaves ~16px for the transcript and virtua renders nothing.
       minSize still applies when the user opens Insights (full-bleed overlay is accepted). */
    const defaultSize = isMobilePhone ? 0 : minSize

    return (
        <Panel
            ref={ref}
            id={AI_PANEL_ID}
            minSize={minSize}
            defaultSize={defaultSize}
            collapsible
            onExpand={() => onExpand(false)}
            onCollapse={() => onCollapse(false)}
            collapsedSize={0}
            className={animateSize ? AI_PANEL_SIZE_TRANSITION_CLASSNAME : undefined}>
            {children}
        </Panel>
    )
}
